import { mappers } from './utils';
import { IPublishOfferParams, TPublishOfferResult } from './types';
import { THeaders } from '../../types/request';
import { fetchPublishOffer } from '../../repositories/monolith-python/v3/publish-offer';
import { EPublishOfferErrorCode } from '../../redux/reducers';

export async function publishOffer(params: IPublishOfferParams): Promise<TPublishOfferResult> {
  const { httpApi, logger, parameters, subdomain } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const requestConfig = {
    headers,
    subdomain,
  };

  try {
    const response = await fetchPublishOffer({
      httpApi,
      parameters,
      config: { requestConfig },
      mappers,
    });

    return response as TPublishOfferResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос POST /v3/offers/',
      degradation: 'Пользователь не может разместить объявление',
    });

    return {
      success: false,
      statusCode: error.statusCode,
      payload: {
        errorCode: error.type || EPublishOfferErrorCode.fatalError,
        errorMessage: 'Что-то пошло не так. Попробуйте повторить позднее',
        errors: null,
      },
    };
  }
}
